const MANIFEST_STYLES = {
  accordion: {
    hashed: 'accordion.af6306fe86b2e94766c2c392b9bd0d96.min.css',
    versioned: 'accordion.min.css'
  },
  alertBox: {
    hashed: 'alert-box.5b4d144c3253064513473445b4eba069.min.css',
    versioned: 'alert-box.min.css'
  },
  button: {
    hashed: 'button.e1c51986daf915b3a1f6804b904e9296.min.css',
    versioned: 'button.min.css'
  },
  carousel: {
    hashed: 'carousel.2324e8f1d5d6c1c1ffa2f38542f0676d.min.css',
    versioned: 'carousel.min.css'
  },
  combobox: {
    hashed: 'combobox.b5600c640ef20672dccb17d0947953c9.min.css',
    versioned: 'combobox.min.css'
  },
  controlIcon: {
    hashed: 'control-icon.107485af736c953d20f01dea06910bec.min.css',
    versioned: 'control-icon.min.css'
  },
  detailsBanner: {
    hashed: 'details-banner.cee6ed65ad5ec1a7a188bc886b0e02fa.min.css',
    versioned: 'details-banner.min.css'
  },
  embeddedTextHero: {
    hashed: 'embedded-text-hero.fb30874f005b9ea62b344195fc33a7f1.min.css',
    versioned: 'embedded-text-hero.min.css'
  },
  fieldSet: {
    hashed: 'field-set.5f8e8f66a61903f3a42030497226611c.min.css',
    versioned: 'field-set.min.css'
  },
  grid: {
    hashed: 'grid.48cc7fb1febcf653dc6008d63393a402.min.css',
    versioned: 'grid.min.css'
  },
  hidden: {
    hashed: 'hidden.cf3e6718c3a005e721d90e2297c95d54.min.css',
    versioned: 'hidden.min.css'
  },
  icon: {
    hashed: 'icon.eb5c777db42e5cc9ce1e03ab8bf69980.min.css',
    versioned: 'icon.min.css'
  },
  listbox: {
    hashed: 'listbox.06cc81b42057db9baaa5fa5f26cf606a.min.css',
    versioned: 'listbox.min.css'
  },
  modalDialog: {
    hashed: 'modal-dialog.201b5e9c322fb342577907264c4e67b9.min.css',
    versioned: 'modal-dialog.min.css'
  },
  pagination: {
    hashed: 'pagination.784f87acf82ba6d53fc0f096f7692d75.min.css',
    versioned: 'pagination.min.css'
  },
  popover: {
    hashed: 'popover.770dc932fac13c157a6d387a488fcc54.min.css',
    versioned: 'popover.min.css'
  },
  priceBar: {
    hashed: 'price-bar.689cea7e3eba9f9c0940542cb61ed7b0.min.css',
    versioned: 'price-bar.min.css'
  },
  pricing: {
    hashed: 'pricing.53dd6c06b13cb44d0bdca37c4d0f21a5.min.css',
    versioned: 'pricing.min.css'
  },
  progressBar: {
    hashed: 'progress-bar.6b81465261734a1d69c413ae0d1de54c.min.css',
    versioned: 'progress-bar.min.css'
  },
  progressiveImage: {
    hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
    versioned: 'progressive-image.min.css'
  },
  promoBar: {
    hashed: 'promo-bar.cb76b61d102ab8348fd90625377fef59.min.css',
    versioned: 'promo-bar.min.css'
  },
  ratingsStars: {
    hashed: 'ratings-stars.303c7a25956758f27fbca2c7d7dd5db1.min.css',
    versioned: 'ratings-stars.min.css'
  },
  secondaryTile: {
    hashed: 'secondary-tile.bcc65db02f3bdb65dc89b2c4dcd31ec0.min.css',
    versioned: 'secondary-tile.min.css'
  },
  selectionSet: {
    hashed: 'selection-set.daece0d18173a8388e0d940b38d38afd.min.css',
    versioned: 'selection-set.min.css'
  },
  spinner: {
    hashed: 'spinner.577f2755aed546aea2a5d6e093ad4923.min.css',
    versioned: 'spinner.min.css'
  },
  standardBanner: {
    hashed: 'standard-banner.76d667c53b1cf3c30aba5b0721ad162f.min.css',
    versioned: 'standard-banner.min.css'
  },
  standardHero: {
    hashed: 'standard-hero.646d0b855a60167e0db791961047701c.min.css',
    versioned: 'standard-hero.min.css'
  },
  standardTile: {
    hashed: 'standard-tile.91a35dfaaf6b049064d9279f5aec633d.min.css',
    versioned: 'standard-tile.min.css'
  },
  stepIndicator: {
    hashed: 'step-indicator.313a77586049605c8ff8f58a12ff1a3a.min.css',
    versioned: 'step-indicator.min.css'
  },
  table: {
    hashed: 'table.319c4f215805d92735d276ef7385de1a.min.css',
    versioned: 'table.min.css'
  },
  tabs: {
    hashed: 'tabs.accea9090f7f5132e8837ae24cedf130.min.css',
    versioned: 'tabs.min.css'
  },
  thumbnailsHero: {
    hashed: 'thumbnails-hero.173471cf13da593eb3432ef44b6cc55f.min.css',
    versioned: 'thumbnails-hero.min.css'
  },
  toggleSwitch: {
    hashed: 'toggle-switch.8512fe5783e73b549b0d2fb25e986af3.min.css',
    versioned: 'toggle-switch.min.css'
  },
  visible: {
    hashed: 'visible.575cdd684fb3556e4bc542654e6dbeea.min.css',
    versioned: 'visible.min.css'
  },
  zoomControls: {
    hashed: 'zoom-controls.58ebe506b2ffbcf975e9147f7d5fbfe6.min.css',
    versioned: 'zoom-controls.min.css'
  },
  core: {
    hashed: 'core.117122f6c924bc21acf04264b9b2297b.min.css',
    versioned: 'core.min.css'
  },
  utility: {
    hashed: 'utility.5373f7525e952dd6794ceed6788b2fb5.min.css',
    versioned: 'utility.min.css'
  }
};
export { MANIFEST_STYLES };